// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports, import/no-restricted-paths, babel/camelcase, init-declarations */
// FIXME: remove this disable directive and fix the ESLint error(s)

// @ts-expect-error: Flow to TS migration.
import _ from "lodash"
import moment from "moment"
import { BOARDING_PASS_AVAILABILITY_NEVER } from "@kiwicom/frontend-common/records/Flight"

import { BOOKING_STATUSES } from "../consts/booking"
import { SERVICES, SERVICES_STATUSES } from "../consts/additionalServices"
import airlineRestrictions from "../../../data/airlineRestrictions.json"

export default class Booking {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(args: any) {
    // @ts-expect-error: Flow to TS migration.
    this.id = Number(args.id) // Number
    // @ts-expect-error: Flow to TS migration.
    this.created = args.created // timestamp
    // @ts-expect-error: Flow to TS migration.
    this.authToken = args.authToken // string
    // @ts-expect-error: Flow to TS migration.
    this.status = args.status // string [new/processed/refunded]
    // @ts-expect-error: Flow to TS migration.
    this.displayStatus = args.displayStatus
    // @ts-expect-error: Flow to TS migration.
    this.blocked = args.blocked // bool
    // @ts-expect-error: Flow to TS migration.
    this.blockers = args.blockers // array
    // @ts-expect-error: Flow to TS migration.
    this.config = args.config // object {config: {allowed_to_change: {}}}
    // @ts-expect-error: Flow to TS migration.
    this.bookingChanges = args.bookingChanges // object {config: {allowed_to_change: {}}}
    // @ts-expect-error: Flow to TS migration.
    this.additionalContacts = args.additionalContacts // List
    // @ts-expect-error: Flow to TS migration.
    this.actions = args.actions // object
    // @ts-expect-error: Flow to TS migration.
    this.insurancePricing = args.insurancePricing // object
    // @ts-expect-error: Flow to TS migration.
    this.isPassthroughBooking = args.isPassthroughBooking // boolean
    // @ts-expect-error: Flow to TS migration.
    this.flightsHistory = args.flightsHistory // List
    // @ts-expect-error: Flow to TS migration.
    this.additionalServices = args.additionalServices // OrderedSet<Record>
    // @ts-expect-error: Flow to TS migration.
    this.pendingFlightChangeOptions = args.pendingFlightChangeOptions // List
    // @ts-expect-error: Flow to TS migration.
    this.pendingRequests = args.pendingRequests // List
    // @ts-expect-error: Flow to TS migration.
    this.assets = args.assets // object
    // @ts-expect-error: Flow to TS migration.
    this.bags = args.bags // number
    // @ts-expect-error: Flow to TS migration.
    this.customer = args.customer // Customer
    // @ts-expect-error: Flow to TS migration.
    this.journey = args.journey // Journey
    // @ts-expect-error: Flow to TS migration.
    this.journeyWithHidden = args.journeyWithHidden // Journey
    // @ts-expect-error: Flow to TS migration.
    this.guarantee = args.guarantee
    // @ts-expect-error: Flow to TS migration.
    this.passengers = args.passengers // Passenger[]
    // @ts-expect-error: Flow to TS migration.
    this.infantsConditions = args.infantsConditions // object
    // @ts-expect-error: Flow to TS migration.
    this.payment = args.payment // Payment
    // @ts-expect-error: Flow to TS migration.
    this.sandbox = args.sandbox // boolean
    // @ts-expect-error: Flow to TS migration.
    this.ticketing_allowed = args.ticketing_allowed // Null / String
    // @ts-expect-error: Flow to TS migration.
    this.cancelRequested = args.cancelRequested // timestamp
    // @ts-expect-error: Flow to TS migration.
    this.pendingRefund = args.pendingRefund // BookingPendingRefund
    // @ts-expect-error: Flow to TS migration.
    this.refundOption = args.refundOption // object - grace_period
    // @ts-expect-error: Flow to TS migration.
    this.refundOptions = args.refundOptions // object - type BookingRefundOptions - voluntary
    // @ts-expect-error: Flow to TS migration.
    this.refundMethods = args.refundMethods // Set
    // @ts-expect-error: Flow to TS migration.
    this.netverify = args.netverify // object
    // @ts-expect-error: Flow to TS migration.
    this.scheduleChange = args.scheduleChange // object
    // @ts-expect-error: Flow to TS migration.
    this.billingDetails = args.billingDetails // object
    // @ts-expect-error: Flow to TS migration.
    this.baggages = args.baggages
    // @ts-expect-error: Flow to TS migration.
    this.checkIn = args.checkIn
    // @ts-expect-error: Flow to TS migration.
    this.availableBaggage = args.availableBaggage
    // @ts-expect-error: Flow to TS migration.
    this.blueRibbonBags = args.blueRibbonBags
    // @ts-expect-error: Flow to TS migration.
    this.refundOffers = args.refundOffers
    // @ts-expect-error: Flow to TS migration.
    this.reservationsDetails = args.reservationsDetails // ?ReservationDetails
    // @ts-expect-error: Flow to TS migration.
    this.partnerType = args.partnerType
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  hasAlternativesOffered(): boolean {
    return (
      // @ts-expect-error: Flow to TS migration.
      this.pendingFlightChangeOptions.size > 0 &&
      // @ts-expect-error: Flow to TS migration.
      this.additionalServices.filter(
        // @ts-expect-error: Flow to TS migration.
        (service) =>
          service.status === SERVICES_STATUSES.OPEN && service.category === SERVICES.CHANGE_FLIGHTS,
      ).size === 0
    )
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  isCompletionNeeded(): boolean {
    return (
      // @ts-expect-error: Flow to TS migration.
      this.status === BOOKING_STATUSES.CONFIRMED &&
      // @ts-expect-error: Flow to TS migration.
      this.config.document.need !== BOARDING_PASS_AVAILABILITY_NEVER &&
      this.getIncompletePassengers().length > 0
    )
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  isCompletionNeededByDefault(): boolean {
    return (
      // @ts-expect-error: Flow to TS migration.
      this.status === BOOKING_STATUSES.CONFIRMED &&
      // @ts-expect-error: Flow to TS migration.
      this.config.document.need !== BOARDING_PASS_AVAILABILITY_NEVER
    )
  }

  requiresBulkCompletion() {
    return (
      // @ts-expect-error: Flow to TS migration.
      this.journey
        .getAirlines()
        // @ts-expect-error: Flow to TS migration.
        .some((airline) => _.get(airlineRestrictions, [airline, "bulkCheckin"]))
    )
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  canChange(what: any): boolean {
    return (
      // @ts-expect-error: Flow to TS migration.
      !this.blocked &&
      // @ts-expect-error: Flow to TS migration.
      this.status === "confirmed" &&
      // @ts-expect-error: Flow to TS migration.
      this.journey.getTimeUntil("hours") >= this.config.allowedToChange[what]
    )
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  canOrderAdditionalServicesBags(): boolean {
    // @ts-expect-error: Flow to TS migration.
    const hoursUntilLastDeparture = this.journey
      .get("trips")
      .last()
      .getDeparture()
      .getIn(["when", "utc"])
      .diff(moment.utc(), "hours")
    // @ts-expect-error: Flow to TS migration.
    return hoursUntilLastDeparture >= this.config.allowedToChange.bags
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  canChangeDocuments(): boolean {
    // @ts-expect-error: Flow to TS migration.
    const hoursAllowedToChange = this.config.allowedToChange.documents
    // @ts-expect-error: Flow to TS migration.
    const hoursUntilLastDeparture = this.journey
      .getFlights()
      .last()
      .getIn(["departure", "when", "utc"])
      .diff(moment.utc(), "hours")
    return hoursUntilLastDeparture >= hoursAllowedToChange
  }

  hasChangeFlightsBlocked() {
    return _.some([
      // @ts-expect-error: Flow to TS migration.
      this.blocked,
      // @ts-expect-error: Flow to TS migration.
      !this.config.allowedToChangeItinerary,
      // @ts-expect-error: Flow to TS migration.
      this.additionalServices.filter(
        (
          // @ts-expect-error: Flow to TS migration.
          x, // already have "blocking" additional service
        ) =>
          x.status === SERVICES_STATUSES.PENDING ||
          x.status === SERVICES_STATUSES.CLOSED ||
          x.status === SERVICES_STATUSES.OFFERED ||
          x.status === SERVICES_STATUSES.OPEN,
      ).size,
      // @ts-expect-error: Flow to TS migration.
      this.status !== BOOKING_STATUSES.CONFIRMED,
    ])
  }

  // additional services that don't require confirmation
  // FIXME: add "@flow" annotation to this file for type checking to work

  hasAdditionalServicesAllowed(): boolean {
    return (
      // @ts-expect-error: Flow to TS migration.
      this.journey.endsInFuture() &&
      // @ts-expect-error: Flow to TS migration.
      (this.status === BOOKING_STATUSES.CONFIRMED || this.status === BOOKING_STATUSES.CLOSED)
    )
  }

  // additional services that require confirmation of booking
  // FIXME: add "@flow" annotation to this file for type checking to work

  hasAllAdditionalServicesAllowed(): boolean {
    // @ts-expect-error: Flow to TS migration.
    return this.journey.endsInFuture() && this.status === BOOKING_STATUSES.CONFIRMED
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  hasNetverifyAllowed(): boolean {
    return (
      // @ts-expect-error: Flow to TS migration.
      this.netverify && (this.netverify.status === "initiate" || this.netverify.status === "retry")
    )
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  hasBagsWithPaxAssociated(): boolean {
    // @ts-expect-error: Flow to TS migration.
    return _.some(this.passengers.map((pax) => _.isNumber(pax.bags)))
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  hasChangeFlightAllowed(): boolean {
    return (
      // @ts-expect-error: Flow to TS migration.
      this.journey.isChangeAllowedForAnyTrip(this.config.allowedToChange.flights) &&
      // @ts-expect-error: Flow to TS migration.
      this.config.allowedToChangeItinerary
    )
  }

  // POBEDA doesn't support free baggage anymore
  // ===

  // FIXME: add "@flow" annotation to this file for type checking to work

  canChangeFlights(): boolean {
    return (
      !this.hasChangeFlightsBlocked() &&
      this.hasChangeFlightAllowed() &&
      // @ts-expect-error: Flow to TS migration.
      !this.journey.hasTransfer()
    )
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  canChangeBagsUntilMoment(): string {
    // @ts-expect-error: Flow to TS migration.
    const departureMoment = this.journey.getDeparture().getIn(["when", "utc"])
    // @ts-expect-error: Flow to TS migration.
    return moment(departureMoment).subtract(this.config.allowedToChange.bags, "hours")
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  canChangeBags(): boolean {
    // TODO rewrite to selector
    const canChangeUntilMoment = this.canChangeBagsUntilMoment()

    return (
      // @ts-expect-error: Flow to TS migration.
      !this.blocked &&
      // @ts-expect-error: Flow to TS migration.
      this.status === BOOKING_STATUSES.CONFIRMED &&
      moment().isBefore(canChangeUntilMoment)
    )
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  getBagsCount(): number {
    // Filter just additionalServices that with action == "addBags"
    // @ts-expect-error: Flow to TS migration.
    const additionalServices = this.additionalServices.filter(
      // @ts-expect-error: Flow to TS migration.
      (x) => x.category === SERVICES.BAGGAGE,
    )

    const completedAdditionalServices = additionalServices.filter(
      // @ts-expect-error: Flow to TS migration.
      (x) => x.status === SERVICES_STATUSES.CONFIRMED,
    )

    const amountOfBagsOfCompletedAdditionalServices = completedAdditionalServices.reduce(
      // Fix this the next time the file is edited. (Flow to TS)
      // @ts-expect-error: Flow to TS migration.
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      (sum, x) => sum + (x.params?.bags || 0), // there's a case with missing params.bags
      0,
    )

    return this.hasBagsWithPaxAssociated()
      ? // Fix this the next time the file is edited. (Flow to TS)
        // @ts-expect-error: Flow to TS migration.
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        this.passengers.reduce((acc, pax) => (pax.bags || 0) + acc, 0) +
          amountOfBagsOfCompletedAdditionalServices
      : // Fix this the next time the file is edited. (Flow to TS)
        // @ts-expect-error: Flow to TS migration.
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        this.bags + amountOfBagsOfCompletedAdditionalServices
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/array-type
  getIncompletePassengers(): Array {
    // @ts-expect-error: Flow to TS migration.
    return this.passengers.filter((pax) => !pax.document.code)
  }

  getAdditionalServicesToPay() {
    // @ts-expect-error: Flow to TS migration.
    return this.additionalServices.filter((x) => x.status === SERVICES_STATUSES.OPEN).toJS()
  }

  // FIXME: add "@flow" annotation to this file for type checking to work

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getPendingInsuranceAdditionalServicesByPassenger(pid: any): string | null | undefined {
    let result

    // @ts-expect-error: Flow to TS migration.
    const additionalServices = this.additionalServices.filter(
      // @ts-expect-error: Flow to TS migration.
      (x) => x.category === SERVICES.INSURANCE && x.status === SERVICES_STATUSES.OPEN,
    )

    // @ts-expect-error: Flow to TS migration.
    additionalServices.forEach((x) => {
      // @ts-expect-error: Flow to TS migration.
      x.params.forEach((p) => {
        if (p.pid === pid) {
          result = p.insurance
        }
      })
    })

    return result
  }
}
